import {
  DROPDOWN_PAGE,
  ListParams,
  PagedResult,
  panelDelete,
  panelGet,
  panelPost,
  panelPut,
} from "./panel.api";
import { SorItem, SorItemPayload } from "./types";

/** sor-item — /sorItem */
export const sorItemApi = {
  getAll: () => panelGet<SorItem[]>("/sorItem", DROPDOWN_PAGE),
  getById: (id: string) => panelGet<SorItem>(`/sorItem/${id}`),
  /** Paged + searchable list backing the Manage Catalog "SOR ID" tab. */
  list: (params: ListParams = {}) =>
    panelGet<PagedResult<SorItem>>("/sorItem/get-sor-list", {
      page: 0,
      size: 20,
      orderBy: "sorId",
      ...params,
    }),
  create: (payload: SorItemPayload) => panelPost<SorItem>("/sorItem", payload),
  update: (id: string, payload: SorItemPayload) => panelPut<SorItem>(`/sorItem/${id}`, payload),
  remove: (id: string) => panelDelete(`/sorItem/${id}`),
  /** Export takes a list of SOR ids. */
  exportItems: (ids: string[]) => panelPost("/sorItem/export", ids),
  /**
   * The SOR items for a category in a region, each `value` already resolved to
   * that region's rate — what Work Order step 2 prices lines with.
   */
  lookup: (category: string, region: string) =>
    panelGet<PagedResult<SorItem>>("/sorItem/lookup", { category, region }),
};
